const { getElement, getElements } = window.BAO.Utils

export class SiteDrawers extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this._activeDrawerKey = ''

    window.drawers = this

    this.drawerKeys
      .filter((key) => !this.triggerKeys.includes(key))
      .forEach((key) =>
        console.info(`Drawer exists for ${key} but there is no trigger`),
      )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.activeDrawerKey = ''
      }
    })
  }

  handleClick (e) {
    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      UNKNOWN: 'UNKNOWN',
    }
    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.backdrop) !== null) {
        return EVENTS.BACKDROP
      } else if (e.target.closest(this.config.matches.drawer) !== null) {
        if (e.detail !== 0) {
          const dialogDimensions = e.target
            .closest(this.config.matches.drawer)
            .getBoundingClientRect()

          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            return EVENTS.BACKDROP
          }
        }
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) return
    e.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      const trigger = e.target.closest(this.config.matches.trigger)
      const key = trigger.getAttribute('data-drawers-trigger')

      this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
    }

    if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
      this.activeDrawerKey = ''
    }
  }

  /**
   * @param {string} key
   */
  open (key) {
    this.activeDrawerKey = key
  }

  close () {
    this.activeDrawerKey = ''
  }

  get triggerKeys () {
    return getElements('[data-drawers-trigger]').map((el) =>
      el.getAttribute('data-drawers-trigger'),
    )
  }

  get drawerKeys () {
    return getElements('[data-module-drawers-drawer]').map((el) =>
      el.getAttribute('data-module-drawers-drawer'),
    )
  }

  get hasAlreadyBeenUsed () {
    const el = getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawerEls.some((drawer) => drawer.isOpen)
  }

  get drawerEls () {
    return Array.from(document.querySelectorAll(this.config.matches.drawer))
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    const prevKey = this._activeDrawerKey
    this._activeDrawerKey = key

    this.drawerEls.forEach((drawer) => (drawer.isOpen = drawer.key === key))

    this.config.elements.drawers.classList.toggle(
      this.config.classes.activeClass,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.drawersOpenUtility,
      this.aDrawerIsOpen,
    )

    if (prevKey) {
      document.body.classList.remove(`drw-Drawers-${prevKey}`)
    }

    if (key !== '') {
      this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
      document.body.classList.add(`drw-Drawers-${key}`)
    } else {
      this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
    }

    document.dispatchEvent(new CustomEvent('drawer-changed'))
  }

  get config () {
    return {
      matches: {
        trigger: '[data-drawers-trigger]',
        subNav: '[data-drawers-sub-nav]',
        close: '[data-drawers-close]',
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawer: '[is="site-drawer"]',
      },
      classes: {
        activeClass: 'drw-Drawers-active',
        activeDrawerClass: 'drw-Drawer-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      },
      elements: {
        body: document.body || document.documentElement,
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawers: document.querySelector('site-drawers'),
      },
    }
  }
}

customElements.define('site-drawers', SiteDrawers)
